import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ContentHub from './ContentHub';
import ContentHubManagement from "./ContentHubManagement";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<ContentHub />} />
                <Route path="/manage" element={<ContentHubManagement />} />
            </Routes>
        </Router>
    );
}

export default App;